import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PurchaseCreationPage } from '@/features/purchases/components/PurchaseCreationPage';

const searchSchema = z.object({
  prestationId: z.coerce.number().optional(),
});

export const Route = createFileRoute('/$commiteeSlug/suppliers/$supplierId/orders/create')({
  component: PurchaseCreationPage,
  validateSearch: searchSchema,
});
